// extracted by mini-css-extract-plugin
module.exports = {"ModalInfo":"ModalInfo_ModalInfo__1MHbW","CloseIcon":"ModalInfo_CloseIcon__3lqGQ","ModalLogo":"ModalInfo_ModalLogo__FoomD"};